import { Injectable } from '@angular/core';
import { ConnectionService } from './conexion.service';
import { News } from '../models/news';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  collection: string = 'news';

  private data: Promise<News[]> = null;

  constructor(private connectionServ: ConnectionService) {
    this.data = this.connectionServ.readNews(this.collection);
  }

  getVisible() {
    return this.data;
  }

  getById(id: string) {
    return this.data.then((elements) => {
      return elements.find((element) => element.id == id);
    });
  }
}
